<template>
  <div class="con-wrap full-page" style="background-color: #fff">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div class="query-box">
        <el-form-item class="r-20" prop="orderNum">
          <el-input
            v-model="queryForm.orderNum"
            @keyup.enter.native="query"
            placeholder="工单编号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="stationName">
          <el-input
            v-model="queryForm.stationName"
            @keyup.enter.native="query"
            placeholder="站址名称"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="name">
          <el-input
            v-model="queryForm.name"
            @keyup.enter.native="query"
            placeholder="接单人员"
          ></el-input>
        </el-form-item>

        <el-form-item class="date-input" style="margin-right:0">
          <date-picker
            :startTime="queryForm.dispatchStart"
            :endTime="queryForm.dispatchEnd"
            :startText="startText"
            :endText="endText"
            @changeStart="changeStart"
            @changeEnd="changeEnd"
          >
          </date-picker>
        </el-form-item>
        <el-form-item class="r-20" prop="plate">
          <el-input
            v-model.trim="queryForm.plate"
            @keyup.enter.native="query"
            placeholder="车牌号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="receiptDate">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="queryForm.receiptDate"
            type="date"
            placeholder="回单日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="hasPerm('order:manage:receipt:list')"
            type="primary"
            @click="query"
            >查询</el-button
          >
          <el-button v-if="hasPerm('order:manage:receipt:list')" @click="reset"
            >取消</el-button
          >
        </el-form-item>
      </div>

      <div style="margin-bottom: 20px">
        <el-button
          v-if="hasPerm('order:manage:receipt:review')"
          type="primary"
          @click="examineOrder"
          >审核</el-button
        >
        <el-button
          v-if="hasPerm('order:manage:export')"
          type="primary"
          @click="exportData"
          >工单导出</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
      @row-click="handleClickTableRow"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="24"
        align="center"
        style="padding: 0"
      ></el-table-column>
      <el-table-column type="index" label="序号" width="45"></el-table-column>
      <el-table-column
        prop="subjectNum"
        label="工单编号"
        width="150"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="stationName"
        label="站址名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="receiveName"
        label="接单人员"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="plateNumList"
        label="车牌号"
        show-overflow-tooltip
        min-width="100"
      >
        <template slot-scope="{ row }">
          <el-tooltip placement="top" :disabled="row.plateNumList.length <= 1">
            <div slot="content" v-if="row.plateNumList.length > 1">
              <span v-for="(item, index) in row.plateNumList" :key="index">{{
                item + "," + " "
              }}</span>
            </div>
            <span v-if="row.plateNumList.length > 1" class="modify">
              <el-select v-model="row.plateNum">
                <el-option
                  v-for="(item, index) in row.plateNumList"
                  :key="index + item"
                  :label="item"
                  :value="index"
                  @click.native="gotoMonitor(item)"
                ></el-option>
              </el-select>
            </span>
            <span
              v-else
              style="cursor: pointer; color: #0094ff"
              @click="gotoMonitor(row.plateNumList[0])"
              >{{ row.plateNumList[0] }}</span
            >
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="vin"
        label="车架号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="dispatchTime"
        label="派单时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="receiveTime"
        label="接单时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="receiptTime"
        label="回单时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="takeTime"
        label="工单历时"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="receiptState" label="回单结果">
        <template slot-scope="scope">
          <span v-if="scope.row.receiptState == 1" class="btn-red"
            >未完成发电</span
          >
          <span v-else-if="scope.row.receiptState == 2" class="btn-green"
            >完成发电</span
          >
        </template>
        <template slot="header">
          <span>回单结果</span>
          <span @click="receiptChange" class="iconfont icon-sort"></span>
        </template>
      </el-table-column>
      <el-table-column prop="receiveState" label="审核状态">
        <template slot-scope="scope">
          <span v-if="scope.row.orderReview == 1" class="btn-gray">待审核</span>
          <span v-else-if="scope.row.orderReview == 2" class="btn-red"
            >审核未通过</span
          >
          <span v-else-if="scope.row.orderReview == 3" class="btn-green"
            >审核通过</span
          >
        </template>
        <template slot="header">
          <span>审核状态</span>
          <span @click="reviewChange" class="iconfont icon-sort"></span>
        </template>
      </el-table-column>
      <el-table-column prop="businessType" label="工单业务类型" min-width="110">
        <template slot-scope="scope">
          <span v-if="scope.row.businessType == 1">基站</span>
          <span v-else-if="scope.row.businessType == 2">银行</span>
          <span v-else></span>
        </template>
        <template slot="header">
          <span>工单业务类型</span>
          <span @click="businessChange" class="iconfont icon-sort"></span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="210" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('order:manage:info')"
            @click.stop="getOrderInfo(scope.row)"
            style="margin-left: 10px"
            >详情</el-button
          >
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('order:manage:scene:task')"
            @click.stop="getpic(scope.row)"
            >现场照片</el-button
          >
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('order:manage:receipt:list')"
            @click.stop="getReceiptInfo(scope.row)"
            >回单信息</el-button
          >
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('order:manage:receipt:count')"
            @click.stop="getStatistics(scope.row)"
            >统计</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!--审核-->
    <el-dialog
      title="审核"
      :visible.sync="examineVisible"
      class="examine-dialog"
    >
      <div v-if="orderState" class="examine-info">
        <div
          class="examine-box"
          v-for="(item, index) in reviewInfo"
          :key="index"
        >
          <p class="dialog-title">
            {{ $judgeEmpty(item.receiveName) }}（{{ item.plateNum }}）
          </p>
          <el-row :gutter="20">
            <el-col :span="6" class="dialog-label">接单时间</el-col>
            <el-col :span="18">{{ $judgeEmpty(item.receiveTime) }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" class="dialog-label">审核状态</el-col>
            <el-col :span="18">{{ stateRead(item.orderReview) }}</el-col>
          </el-row>
          <el-row :gutter="20" v-if="item.orderReview == 2">
            <el-col :span="6" class="dialog-label">审核说明</el-col>
            <el-col :span="18">{{ $judgeEmpty(item.reviewMessage) }}</el-col>
          </el-row>
        </div>
      </div>
      <el-form
        ref="examineForm"
        :model="examineForm"
        size="mini"
        :inline="true"
        v-else
      >
        <div v-for="(item, index) in reviewInfo" :key="index">
          <div v-if="item.orderReviewTmp != 1">
            <p class="dialog-title">
              {{ $judgeEmpty(item.receiveName) }}（{{ item.plateNum }}）
            </p>
            <el-row :gutter="20">
              <el-col :span="4" class="dialog-label">接单时间</el-col>
              <el-col :span="18">{{ $judgeEmpty(item.receiveTime) }}</el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="4" class="dialog-label">审核状态</el-col>
              <el-col :span="18">{{ stateRead(item.orderReview) }}</el-col>
            </el-row>
            <el-row :gutter="20" v-if="item.orderReview == 2">
              <el-col :span="4" class="dialog-label">审核说明</el-col>
              <el-col :span="18">{{ $judgeEmpty(item.reviewMessage) }}</el-col>
            </el-row>
          </div>
          <div v-else>
            <p class="dialog-title">
              {{ item.receiveName }}（{{ item.plateNum }}）
            </p>
            <el-row :gutter="20">
              <el-col :span="4" class="dialog-label">接单时间</el-col>
              <el-col :span="18">{{ $judgeEmpty(item.receiveTime) }}</el-col>
            </el-row>
            <el-form-item
              :prop="'options.' + index + '.orderReview'"
              label="审核"
              class="must"
            >
              <el-select v-model="item.orderReview" placeholder="请审核">
                <el-option label="审核通过" value="3"></el-option>
                <el-option label="审核不通过" value="2"></el-option>
                <el-option label="待审核" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :prop="'options.' + index + '.reviewMessage'"
              v-if="item.orderReview == 2"
              label="未通过原因"
            >
              <el-input
                type="textarea"
                v-model="item.reviewMessage"
                placeholder="请输入未通过原因"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span v-if="!orderState" slot="footer" class="dialog-footer">
        <el-button @click="examineVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 详情弹窗 -->
    <el-dialog
      title="详情"
      :visible.sync="infoVisible"
      class="mini-dialog info-box"
    >
      <div class="con-left">
        <p class="dialog-title">工单信息</p>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">工单编号</el-col>
          <el-col :span="18">{{
            $judgeEmpty(detailsInfoData.subjectNum)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">工单类型</el-col>
          <el-col :span="18">{{ $judgeEmpty(detailsInfoData.type) }}</el-col>
        </el-row>
        <el-row :gutter="20" v-if="detailsInfoData.type === '计划发电'">
          <el-col :span="6" class="dialog-label">停电时间</el-col>
          <el-col
            :span="18"
            v-if="detailsInfoData.startTime || detailsInfoData.endTime"
          >
            {{ $judgeEmpty(detailsInfoData.startTime) }}至
            <br />
            {{ $judgeEmpty(detailsInfoData.endTime) }}
          </el-col>
          <el-row v-else>-</el-row>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">工单状态</el-col>
          <el-col :span="18">{{
            $judgeEmpty(detailsInfoData.receiveState)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">工单内容</el-col>
          <el-col
            :span="18"
            :title="$judgeEmpty(detailsInfoData.content)"
            class="text-overflow"
            >{{ $judgeEmpty(detailsInfoData.content) }}</el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">派单人员</el-col>
          <el-col :span="18">{{
            $judgeEmpty(detailsInfoData.dispatchName)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">接单人员</el-col>
          <el-col
            :span="18"
            :title="$judgeEmpty(detailsInfoData.receiveName)"
            class="text-overflow"
            >{{ $judgeEmpty(detailsInfoData.receiveName) }}</el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">联系电话</el-col>
          <el-col
            :span="18"
            :title="$judgeEmpty(detailsInfoData.phone)"
            class="text-overflow"
            >{{ $judgeEmpty(detailsInfoData.phone) }}</el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">车架号</el-col>
          <el-col
            :span="18"
            :title="$judgeEmpty(detailsInfoData.vin)"
            class="text-overflow"
            >{{ $judgeEmpty(detailsInfoData.vin) }}</el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">车牌号</el-col>
          <el-col
            :span="18"
            :title="$judgeEmpty(detailsInfoData.platNum)"
            class="text-overflow"
            >{{ $judgeEmpty(detailsInfoData.platNum) }}</el-col
          >
        </el-row>
      </div>
      <div class="con-middle">
        <p class="dialog-title">站址信息</p>
        <el-row :gutter="20">
          <el-col :span="8" class="dialog-label">站址名称</el-col>
          <el-col :span="16">{{
            $judgeEmpty(stationInfoData.stationName)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8" class="dialog-label">站址编码</el-col>
          <el-col :span="16">{{ $judgeEmpty(stationInfoData.code) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8" class="dialog-label">经度</el-col>
          <el-col :span="16">{{
            $judgeEmpty(stationInfoData.longitude)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8" class="dialog-label">纬度</el-col>
          <el-col :span="16">{{
            $judgeEmpty(stationInfoData.latitude)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8" class="dialog-label">基站直流负载（A）</el-col>
          <el-col :span="16">{{
            $judgeEmpty(stationInfoData.dcLoadCurrent)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8" class="dialog-label">详细地址</el-col>
          <el-col :span="16">{{ $judgeEmpty(stationInfoData.addr) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8" class="dialog-label">备注</el-col>
          <el-col :span="16">{{ $judgeEmpty(stationInfoData.remark) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8" class="dialog-label">归属分组</el-col>
          <el-col :span="16">{{
            $judgeEmpty(stationInfoData.areaName)
          }}</el-col>
        </el-row>
      </div>
      <div class="con-right">
        <p class="dialog-title">审核信息</p>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">审核状态</el-col>
          <el-col :span="18">{{ $judgeEmpty(infoData.orderReview) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">审核说明</el-col>
          <el-col :span="18">{{ $judgeEmpty(infoData.reviewMessage) }}</el-col>
        </el-row>
      </div>
      <div class="brotherStyle">
        <p class="dialog-title">工单进度</p>
        <div class="time-wrap">
          <span class="time-box">
            <span class="time-label">计时</span>
            <span class="time-con">{{
              $judgeEmpty(infoData.totalTakeTime)
            }}</span>
          </span>
        </div>
        <order-step :orderInfoData="orderInfoData" :step="step"></order-step>
      </div>
    </el-dialog>
    <!-- 回单信息弹窗 -->
    <el-dialog
      title="回单信息"
      :visible.sync="receiptVisible"
      class="mini-dialog receipt-info recept-wrap"
    >
      <div
        class="receipt-box"
        v-for="(item, index) in receiptInfo"
        :key="index"
      >
        <p class="dialog-title">{{ $judgeEmpty(item.receiveName) }}</p>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">回单状态</el-col>
          <el-col :span="18">{{ $judgeEmpty(item.receiptState) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">回单时间</el-col>
          <el-col :span="18">{{ $judgeEmpty(item.receiptTime) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">回单内容</el-col>
          <el-col :span="18">{{ $judgeEmpty(item.receiptMessage) }}</el-col>
        </el-row>
      </div>
    </el-dialog>
    <!-- 工单统计 -->
    <el-dialog
      title="工单统计"
      :visible.sync="StatisticsVisible"
      class="mini-dialog receipt-info"
    >
      <el-row :gutter="20">
        <el-col :span="6" class="dialog-label">工单历时</el-col>
        <el-col :span="18">{{ $judgeEmpty(StatisticsInfo.takeTime) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" class="dialog-label">发电量</el-col>
        <el-col :span="18">{{ $judgeEmpty(StatisticsInfo.power) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" class="dialog-label">发电时长</el-col>
        <el-col :span="18">{{ $judgeEmpty(StatisticsInfo.powerTime) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" class="dialog-label">发电油耗</el-col>
        <el-col :span="18">{{ $judgeEmpty(StatisticsInfo.powerOil) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" class="dialog-label">平均油耗</el-col>
        <el-col :span="18">{{ $judgeEmpty(StatisticsInfo.averageOil) }}</el-col>
      </el-row>
    </el-dialog>
    <!--工单数据导出-->
    <el-dialog
      title="工单导出"
      :visible.sync="exportVisible"
      class="mini-dialog"
    >
      <el-form ref="exportForm" size="mini" :inline="true">
        <el-form-item label="派单时间" class="is-required">
          <date-picker
            :startTime="exportStartTime"
            :endTime="exportEndTime"
            @changeStart="exportStart"
            @changeEnd="exportEnd"
          >
          </date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportVisible = false">取 消</el-button>
        <el-button type="primary" @click="orderExport">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="现场照片"
      :visible.sync="picVisible"
      class="examine-dialog"
    >
      <div
        class="examine-box"
        v-for="(item, index) in scenePhotos"
        :key="index"
      >
        <p class="dialog-title">
          <span>{{ $judgeEmpty(item.personnelName) }}</span
          ><span>({{ $judgeEmpty(item.plateNum) }})</span>
        </p>
        <div class="image-box" v-if="item.urls.length != 0">
          <el-image
            style="width: 100px; height: 100px; margin-right: 10px"
            v-for="url in item.urls"
            :key="url"
            :src="url"
            :zIndex="3000"
            :preview-src-list="item.urls"
            @click.stop="handleClickItem"
          >
          </el-image>
        </div>
        <div v-else style="padding-left: 20px">未上传现场照片</div>
      </div>
      <div v-if="picFlag" class="textBox">
        <p>暂未上传照片</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OrderStep from "../../../components/OrderStep.vue";
import DatePicker from "@/components/DatePicker.vue";
export default {
  components: {
    OrderStep,
    DatePicker,
  },
  data() {
    return {
      startText: "派单开始时间",
      endText: "派单结束时间",
      queryForm: {
        orderNum: "",
        stationName: "",
        name: "",
        plate: "",
        receiptDate: "",
        dispatchStart: "",
        dispatchEnd: "",
      },
      examineVisible: false,
      receiptVisible: false,
      StatisticsVisible: false,
      examineForm: {},
      currentPage: 1,
      limit: 10,
      total: 0,
      // tableHeight: 0,
      tableData: [],
      tableVal: [],
      infoData: {},
      orderInfoData: [],
      detailsInfoData: {},
      stationInfoData: {},
      infoVisible: false,
      receipt: "",
      review: "",
      businessType: "",
      step: 1,
      receiptInfo: [],
      StatisticsInfo: {},
      exportVisible: false,
      exportStartTime: "",
      exportEndTime: "",
      reviewInfo: [],
      orderState: true,
      //现场照片
      picFlag: false,
      scenePhotos: [],
      picVisible: false,
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.tableHeight = window.innerHeight - 400; //后面的50：根据需求空出的高度，自行调整
    // });
    if (this.$route.params.receiptPlateNum) {
      this.queryForm.plate = this.$route.params.receiptPlateNum;
    }
    this.getOrderList();
  },
  methods: {
    // ??? 跳转至运行监控
    gotoMonitor(plate) {
      console.log(plate,'运行监控');
      sessionStorage.setItem("fullMonitorPlate", plate);
      sessionStorage.setItem("isSearch", true);
      const { href } = this.$router.resolve({
        path: "/fullScreenMonitor",
      });
      window.open(href, "_blank");
    },
    changeStart(val) {
      this.queryForm.dispatchStart = val;
    },
    changeEnd(val) {
      this.queryForm.dispatchEnd = val;
    },
    exportStart(val) {
      this.exportStartTime = val;
    },
    exportEnd(val) {
      this.exportEndTime = val;
    },
    async getOrderList() {
      let obj = {
        limit: this.limit,
        page: this.currentPage,
        subjectNum: this.queryForm.orderNum,
        stationName: this.queryForm.stationName,
        name: this.queryForm.name,
        plate: this.queryForm.plate,
        receiptDate: this.queryForm.receiptDate,
        dispatchStart: this.queryForm.dispatchStart,
        dispatchEnd: this.queryForm.dispatchEnd,
        receipt: this.receipt,
        review: this.review,
        businessType: this.businessType,
      };
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/v2/order/manage/receipt/list",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
        this.handleTableData(res.data.list);
      }
    },
    // 处理表格数据
    handleTableData(list) {
      list.forEach((item) => {
        item.plateNum = 0;
      });
    },
    examineOrder() {
      let val = this.tableVal;
      let orderIds = this.$getIds(val);
      this.orderState = false;
      if (this.tableVal.length > 1) {
        this.$message.warning("一次只能选择一条数据");
        return;
      }
      if (val[0].orderReview != 1) {
        this.orderState = true;
      }
      if (orderIds) {
        this.$resetForm(this, "examineForm");
        this.getReviewInfo(orderIds);
        this.examineVisible = true;
      }
    },

    //获取审核工单信息
    async getReviewInfo(subjectId) {
      let _this = this;
      //显示弹框
      let { data: res } = await _this.$axios.get(
        "/api/v2/order/manage/receipt/review/info/" + subjectId
      );
      if (res.code == 1) {
        _this.reviewInfo = res.data;
        _this.examineForm.options = _this.reviewInfo;
        for (let i = 0, length = _this.reviewInfo.length; i < length; i++) {
          if (_this.reviewInfo[i].orderReview == "1") {
            _this.reviewInfo[i].orderReview = "3";
          }
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //审核结果提交
    async saveOrUpdate() {
      let _this = this;
      let { data: res } = await _this.$axios.patch(
        "/api/v2/order/manage/receipt/review",
        this.examineForm.options
      );
      if (res.code == 1) {
        _this.examineVisible = false;
        _this.$resetForm(_this, "examineForm");
        _this.$message.success("操作成功");
        _this.getOrderList();
      } else {
        _this.$message.warning(res.msg);
      }
    },
    reviewChange() {
      this.review = this.review == "" ? 1 : this.review == 1 ? 2 : 1;
      this.receipt = "";
      this.businessType = "";
      this.getOrderList();
    },
    receiptChange() {
      this.receipt = this.receipt == "" ? 1 : this.receipt == 1 ? 2 : 1;
      this.review = "";
      this.businessType = "";
      this.getOrderList();
    },
    businessChange() {
      this.businessType =
        this.businessType == "" ? 1 : this.businessType == 1 ? 2 : 1;
      this.review = "";
      this.receipt = "";
      this.getOrderList();
    },
    query() {
      this.getOrderList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.receipt = "";
      this.review = "";
      this.businessType = "";
      this.queryForm.dispatchStart = "";
      this.queryForm.dispatchEnd = "";
      this.getOrderList();
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val;
      console.log(val);
    },
    handleClickTableRow(row, event, column) {
      console.log(row);
      console.log(column);
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getOrderList();
    },
    //列表详情弹窗内容
    async getOrderInfo(rowData) {
      let id = rowData.id;
      this.step = [];
      //显示弹框
      this.infoVisible = true;
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/v2/order/manage/info/" + id
      );
      if (res.code == 1) {
        this.infoData = res.data;
        this.orderInfoData = res.data.schedules;
        this.detailsInfoData = res.data.details;
        this.stationInfoData = res.data.station;
        // this.审核信息 = res.data.审核信息;
        this.detailsInfoData.receiveState =
          this.detailsInfoData.receiveState == "1"
            ? "待接单"
            : this.detailsInfoData.receiveState == "2"
            ? "已接单"
            : "已回单";
        this.detailsInfoData.type =
          this.detailsInfoData.type == 1 ? "计划发电" : "应急发电";
        this.infoData.orderReview =
          this.infoData.orderReview == 1
            ? "待审核"
            : this.infoData.orderReview == 2
            ? "审核未通过"
            : "审核通过";
        for (let i = 0; i < this.orderInfoData.length; i++) {
          if (this.orderInfoData[i].receiptTime) {
            this.step.push(5);
          } else if (this.orderInfoData[i].powerEndTime) {
            this.step.push(4);
          } else if (this.orderInfoData[i].powerStartTime) {
            this.step.push(3);
          } else if (this.orderInfoData[i].receiveTime) {
            this.step.push(2);
          } else if (this.orderInfoData[i].dispatchTime) {
            this.step.push(1);
          }
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 回单信息
    getReceiptInfo(rowData) {
      this.receiptInfo = [];
      this.receiptVisible = true;
      this.receiptInfo = rowData.receiptMsg;
      for (let i = 0; i < this.receiptInfo.length; i++) {
        this.receiptInfo[i].receiptState =
          this.receiptInfo[i].receiptState == 1 ? "未完成发电" : "完成发电";
      }
    },
    // 工单统计
    async getStatistics(rowData) {
      this.StatisticsVisible = true;
      let _this = this;
      let orderNum = rowData.subjectNum;
      let { data: res } = await _this.$axios.get(
        "/api/order/manage/receipt/count/" + orderNum
      );
      if (res.code == 1) {
        _this.StatisticsInfo = res.data;
        if (_this.StatisticsInfo.averageOil != "") {
          _this.StatisticsInfo.averageOil =
            _this.StatisticsInfo.averageOil + "L/H";
        }
        if (_this.StatisticsInfo.power != "") {
          _this.StatisticsInfo.power = _this.StatisticsInfo.power + "KW·H";
        }
        if (_this.StatisticsInfo.powerOil != "") {
          _this.StatisticsInfo.powerOil = _this.StatisticsInfo.powerOil + "L";
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    exportData() {
      this.exportVisible = true;
      this.exportStartTime = "";
      this.exportEndTime = "";
    },
    orderExport() {
      let _this = this;
      let url = "";
      if (!this.exportStartTime) {
        this.$message.warning("请选择开始时间");
        return false;
      }
      if (!this.exportEndTime) {
        this.$message.warning("请选择结束时间");
        return false;
      }
      url =
        "/api/order/manage/order/export?dispatchStart=" +
        _this.exportStartTime +
        "&dispatchEnd=" +
        _this.exportEndTime;
      window.location.href = url;
      this.exportVisible = false;
    },
    stateRead(data) {
      if (data == 1) {
        return "待审核";
      } else if (data == 2) {
        return "审核未通过";
      } else if (data == 3) {
        return "审核通过";
      }
    },
    async getpic(rowData) {
      this.scenePhotos = [];
      this.picFlag = false;
      let id = rowData.id;
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/v2/order/manage/scene/task/" + id
      );
      if (res.code == 1) {
        if (res.data.length == 0) {
          this.picVisible = true;
          this.picFlag = true;
          return;
        }
        for (let i = 0; i < res.data.length; i++) {
          let obj = {};
          obj.urls = [];
          obj.personnelName = res.data[i].personnelName;
          obj.plateNum = res.data[i].plateNum;
          for (let j = 0; j < res.data[i].imageList.length; j++) {
            obj.urls.push(res.data[i].imageList[j].url);
          }
          this.scenePhotos.push(obj);
        }
        this.picVisible = true;
      } else {
        _this.$message.warning(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.full-page {
  padding: 0 20px;
  background: #fff;
}
.query-box /deep/ .el-date-editor {
  width: 100% !important;
}
.date-input /deep/ {
  .el-form-item__content {
    width: 582px;
    .el-col-1 {
      margin-left: 18px !important;
    }
    .el-col-10 {
      min-width: 260px;
    }
  }
}
.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.examine-dialog /deep/ {
  .el-dialog {
    width: 600px;
  }
  .el-dialog__body {
    color: #333;
  }
  .el-row {
    height: 32px;
    line-height: 32px;
    .dialog-label {
      margin-left: 20px;
      font-weight: normal;
    }
  }
}
.examine-dialog /deep/ .el-form-item__label {
  width: 88px;
  height: 32px;
  margin-left: 20px;
  text-align: left;
  color: #343434;
  font-size: 14px;
}
.examine-dialog /deep/ .el-form-item__content {
  width: 380px;
  height: auto;
}
//详情弹窗样式
.info-box /deep/ .el-dialog {
  width: 1200px;
}
.info-box /deep/ .el-row {
  height: 32px;
  line-height: 32px;
  padding-left: 60px;
  color: #333;
}
.info-box /deep/ .dialog-label {
  font-weight: bold;
}
// ::v-deep .el-dialog__body {
//   display: flex;
//   flex-wrap: wrap;
// }
.con-left {
  width: 30%;
  display: inline-block;
}
.con-middle {
  width: 40%;
  display: inline-block;
}
.con-right {
  width: 30%;
  display: inline-block;
}
.brotherStyle {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
  box-sizing: border-box;
}
.time-wrap {
  width: 180px;
  height: 56px;
  padding: 10px;
  background: #ddf0fe;
  box-sizing: border-box;
}
.time-box {
  width: 100%;
  height: 36px;
  line-height: 36px;
  padding: 0 12px;
  border: 2px solid #18232c;
  border-radius: 6px;
  display: inline-block;
  box-sizing: border-box;
}
.time-con {
  float: right;
  font-size: 18px;
  color: #0094ff;
}
// 回单信息弹窗
.receipt-box {
  height: auto;
  max-height: 460px;
  overflow: auto;
}
.receipt-info /deep/ .el-dialog__body {
  color: #333;
}
.receipt-info /deep/ .el-dialog__body {
  padding-left: 40px;
}
.recept-wrap /deep/ .el-dialog__body {
  padding-left: 20px;
  .el-row {
    padding-left: 20px;
  }
}
.receipt-info /deep/ .el-dialog__footer {
  padding-top: 10px;
}
.dialog-label {
  padding-left: 20px;
  font-weight: bold;
}
.receipt-info /deep/ .el-row {
  height: 34px;
  line-height: 34px;
}
.con-wrap /deep/ .mini-dialog .el-form-item__label {
  width: 110px;
  margin-left: 0;
}
//审核下拉框必选标记
.must {
  position: relative;
}
.must:before {
  content: "*";
  color: #f56c6c;
  font-weight: bold;
  position: absolute;
  left: 8px;
  top: 6px;
}
.examine-dialog .examine-info /deep/ {
  max-height: 570px;
  overflow: auto;
  .el-dialog {
    width: 600px;
  }
  .el-dialog__body {
    color: #333;
  }
  .el-row {
    height: 32px;
    line-height: 32px;
    padding-left: 20px;
    .dialog-label {
      margin: 0;
      font-weight: bold;
    }
  }
}
.modify {
  ::v-deep .el-select {
    height: 30px;
    width: 98px;

    .el-input__suffix {
      position: absolute;
      right: 0 !important;
      left: 70px;
      .el-input__icon {
        line-height: 30px;
      }
    }

    .el-input__inner {
      color: #0094ff;
      width: 98px;
      height: 30px;
      // border: none;
      padding: 0 5px;
    }
  }
}
</style>
